declare let M: any

export class Sidenav{
    private static mainMenuItems: HTMLCollection
    private static mainMenuItemsIcon: HTMLCollection

    public static init(){
        
        let elem = document.getElementsByClassName('sidenav');

        let options = {

        }

        for(let i = 0; i < elem.length; i++){
            var instance = M.Sidenav.init(elem.item(i), options);
        }
        Sidenav.mainMenuItems = document.getElementsByClassName('_mainMenuItem');
        Sidenav.mainMenuItemsIcon = document.getElementsByClassName('_mainMenuItemArrow');
        for(let i = 0; i < Sidenav.mainMenuItemsIcon.length; i++){
            Sidenav.mainMenuItemsIcon.item(i).addEventListener('click', function(event){
                if(Sidenav.mainMenuItemsIcon.item(i).parentElement.classList.contains('active')){
                    Sidenav.mainMenuItemsIcon.item(i).parentElement.classList.remove('active')
                } else {
                    Sidenav.mainMenuItemsIcon.item(i).parentElement.classList.add('active')
                }                
            })
        }

        var closeIcon = document.getElementsByClassName('_sidenavClose')[0]
        closeIcon.addEventListener('click', function(){
            instance.close();
        })
    }

    public static removeActive() {
        for(let i = 0; i < Sidenav.mainMenuItems.length; i++){
            if(Sidenav.mainMenuItems.item(i).classList.contains('active')){
                Sidenav.mainMenuItems.item(i).classList.remove('active')
            }
        }
    }

}